module.exports = __webpack_public_path__ + "img/card-bg-1.e9a0f013.jpg";